import React from "react";
import "./NoMatch.css";
const NoMatch = () => {
  return (
    <div class="no-match">
      <h1>404 Error!!</h1>
    </div>
  );
};

export default NoMatch;
